var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 427,
    viewBox: "0 0 427 427",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M386.715 213.531C379.623 213.531 372.655 213.958 365.808 214.875C286.827 224.29 224.167 286.888 214.814 365.869C213.958 371.982 213.592 378.217 213.531 384.514V388.977C213.469 388.243 213.469 387.448 213.469 386.715C213.469 379.623 213.042 372.655 212.125 365.808C202.71 286.827 140.112 224.29 61.1921 214.875C54.3455 213.958 47.3765 213.531 40.2853 213.531C47.3765 213.531 54.3455 213.103 61.1921 212.186C140.173 202.772 205.4 140.418 212.125 61.1921C212.797 53.2451 213.347 37.351 213.531 29.404C213.714 22.0683 213.531 0 213.531 0C211.941 0 210.291 0 208.701 0.061131C94.753 2.5675 2.5675 94.8142 0.061131 208.762C0 210.352 0 211.941 0 213.531C0 215.12 0 216.709 0.061131 218.299C2.5675 332.186 94.753 424.432 208.701 426.939C210.291 427 211.941 427 213.531 427C215.12 427 216.648 427 218.238 426.939C332.186 424.494 424.432 332.247 426.939 218.299C427 216.709 427 215.12 427 213.531H386.715Z",
    fill: "#F2F2F2",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.531 384.514C213.469 385.248 213.469 385.981 213.469 386.715C213.469 387.448 213.469 388.243 213.531 388.977V384.514Z",
    fill: "#F2F2F2",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M341.111 171.778C388.546 171.778 427 133.324 427 85.8891C427 38.4538 388.546 0 341.111 0C293.676 0 255.222 38.4538 255.222 85.8891C255.222 133.324 293.676 171.778 341.111 171.778Z",
    fill: "#F2F2F2",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootbg);
export default __webpack_public_path__ + "static/media/footbg.e95c261b8f93079c3d5ad5a748775caa.svg";
export { ForwardRef as ReactComponent };